import React, { useState, useEffect, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { store } from '../../store'



const ProjectsPosted = (props) => {

	const globalState = useContext(store);
	const { dispatch } = globalState;
	let history = useHistory()


  const [ projectList, setProjectList] = useState([])

	const fetchData = async () => {

	  const response = await fetch('/api/v1/project_details', {
	    headers: {
	      'Content-Type': 'application/json',
	      'Authorization': globalState.state.Authentication
	    },
	    method: 'get'
	  })
	  const responseJson = await response.json()

	  if (response.ok) {
	    setProjectList(responseJson)
	  } else {
	    alert.show("Server is down.")
	    return false
	  }
	}

	useEffect( () => {
	  fetchData();
	}, []);

	console.log(projectList)

	const copyProject = async (project_id) => {
  	dispatch({ type: 'project',project_id: project_id});
  	history.push({pathname:"/new-project", state:{copyProjectState:true}});
  }

	const ProjectList = projectList.map( project => {
		if(project.status == 'posted')
		{
			return (
      	<tr key={project.id}>
		      <td><Link className="link" to={{pathname:"/project-details-view", state:{ projectId:project.id, projectTitle:project.title}}}>{project.title}</Link></td>
		      <td>{project.creator}</td>
		      <td>{project.update_date}</td>
		      <td>{project.proposal_due_date_dv}</td>
		      {globalState.state.access_role != "accountant" ? <td><button type="button" className="btn btn-link p-0" onClick={()=> copyProject(project.id)}>Create a Copy</button></td>: null }
		    </tr>
    	)
		}

  })

  return (
    <div className="container">
      <div className="row g-2 align-items-center">
        <div className="col-md text-start">
          <h2 className="card-title page-title my-3"><FontAwesomeIcon icon="thumbs-up" /> Projects Posted</h2>
        </div>
    	</div>
    	<div className="col-md mt-4">
    		<table className="table table-bordered table-striped table-sm text-start">
				  <thead>
				    <tr>
				      <th scope="col">Project Title</th>
				      <th scope="col">Created By</th>
				      <th scope="col">Date Posted</th>
				      <th scope="col">Submission Date</th>
				      {globalState.state.access_role != "accountant" ?
				      	<th scope="col"></th>
				      	:
				      	null
				      }
				    </tr>
				  </thead>
				  <tbody>
			    	{ProjectList}
				  </tbody>
				</table>

    	</div>
    </div>
  );
}

export default ProjectsPosted;
